<!-- 提现申请 -->

<template>
  <div class="main">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="applyNum" suffix-icon="el-icon-search" placeholder="搜索申请单号" clearable
        @change="onSearch"></el-input>
      <el-input class="s_input" v-model="storeName" suffix-icon="el-icon-search" placeholder="搜索门店名称" clearable
        @change="onSearch"></el-input>
      <el-select v-model="status" placeholder="选择状态" @change="onSearch" clearable>
        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-date-picker v-model="dateTime" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" clearable @change="handleSelectData" value-format="yyyy-MM-dd"></el-date-picker>
    </div>
    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" :cell-style="reviewRowClass">
        <el-table-column label="序号" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="applyNum" label="申请单号"></el-table-column>
        <el-table-column min-width="150" show-overflow-tooltip prop="bizName" label="门店名称"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="accountType" label="账号类型">
          <template slot-scope="scope">
            <span v-if="scope.row.accountType == '1'">支付宝</span>
            <span v-if="scope.row.accountType == '2'">银行卡</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="accountNum" label="账号"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="accountName" label="真实姓名"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="availableAmount"
          label="可提现金额(元)"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="applyAmount" label="提现金额(元)"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="createdTime" label="申请时间"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="status" label="状态">
          <template slot-scope="scope">
            <span>{{ getStatusText(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" class="btn" type="primary" plain @click="handleCheck(scope.row)"
              v-if="scope.row.status != 0">查看</el-button>
            <el-button size="small" class="btn" type="primary" plain @click="handleApply(scope.row)"
              v-if="scope.row.status == 0">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount">
    </el-pagination>

    <!-- 处理审核弹窗 -->
    <el-dialog title="提现审核" :visible.sync="dialogVisible" @close="handleCloseDialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <el-row class="row">
          <el-col :span="12" class="col">
            <el-form-item label="审核结果：" prop="auditResult">
              <el-select v-model="ruleForm.auditResult" placeholder="请选择" clearable @change="handleSelectVto">
                <el-option v-for="item in auditResultOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row" v-if="ruleForm.auditResult == 2">
          <el-col :span="22" class="col">
            <el-form-item label="不通过原因：" prop="loseContent">
              <el-input type="textarea" v-model="ruleForm.loseContent" placeholder="请输入" maxlength="200" show-word-limit
                :autosize="{ minRows: 5, maxRows: 6 }"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      id: null,
      applyNum: '', // 申请单号
      storeName: '', // 门店名称
      status: '', // 状态
      statusOptions: [{
        value: '0',
        label: '待审核'
      }, {
        value: '1',
        label: '已转账'
      }, {
        value: '2',
        label: '审核失败'
      }, {
        value: '3',
        label: '转账失败'
      },],
      dateTime: [], // 时间区间
      // 表格数据
      tableData: [],
      // 提现弹窗数据
      dialogVisible: false, // 弹窗显隐
      ruleForm: {
        auditResult: '', // 审核结果
        loseContent: '', // 不通过原因
      },
      rules: {
        auditResult: [{
          required: true,
          message: '请选择审核结果',
          trigger: 'blur'
        },
        ],
        loseContent: [{
          required: true,
          message: '请输入不通过原因',
          trigger: 'blur'
        }],
      },
      auditResultOptions: [
        { label: '审核通过', value: 1 },
        { label: '审核不通过', value: 2 },
      ],
      accountVo: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.selectExtractApplyList();
  },
  methods: {
    // 获取列表
    selectExtractApplyList() {
      this.loading = true;
      let params = {
        applyNum: this.applyNum || null,
        bizName: this.storeName || null,
        status: this.status || null,
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      // 时间区间
      if (this.dateTime && this.dateTime.length === 2) {
        params.startTime = this.dateTime[0]
        params.endTime = this.dateTime[1]
      } else {
        params.startTime = null
        params.endTime = null
      }
      this.$axios.get(this.$api.selectExtractApplyList, {
        params
      })
        .then((res) => {
          if (res.code == 100) {
            this.tableData = res.result.list;
            this.totalItemsCount = res.result.totalCount;
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },
    handleSelectVto(value) {
      if (value == 1) {
        this.ruleForm.loseContent = ''
      }
    },
    handleApply(row) {
      this.dialogVisible = true;
      this.id = row.id
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false;
      this.resetForm();
      this.id = null;
    },
    // 表单校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log('error submit!!');
          return false;
        } else {
          this.$axios.put(this.$api.auditingExtractApply, {
            auditMsg: this.ruleForm.loseContent,
            status: this.ruleForm.auditResult,
            id: this.id

          }).then((res) => {
            if (res.code == 100) {
              this.$message.success(res.desc);
              this.handleCloseDialog();
              this.selectExtractApplyList();
            }
          }).catch(err => {
            this.$message({
              message: err.desc,
              type: "error",
            })
          })
        }
        this.handleCloseDialog();
      });
    },
    // 重置表单
    resetForm() {
      this.ruleForm = {};
      this.$refs.ruleForm.resetFields();
    },
    // 时间搜索
    handleSelectData(value) {
      this.dateTime = value
      this.onSearch()
    },
    // 清空
    clearData() {
      this.tableData = [];
      this.currentPage = 1;
    },
    // 搜索
    onSearch() {
      this.clearData();
      this.selectExtractApplyList();
    },
    // 查看
    handleCheck(row) {
      this.$router.push({
        path: '/settlement/detail/withdrawalReviewDetail',
        query: {
          'id': row.id
        }
      })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData();
      this.pageSize = e;
      this.selectExtractApplyList();
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = [];
      this.currentPage = e;
      this.selectExtractApplyList();
    },
    getStatusText(status) {
      switch (String(status)) {
        case '0':
          return "待审核";
        case '1':
          return "已转账";
        case '2':
          return "审核失败";
        case '3':
          return "转账失败";
        default:
          return " ";
      }
    },
    // 审核颜色变化
    reviewRowClass({
      row,
      columnIndex
    }) {
      if (columnIndex == 9) {
        if (row.status == '0' || row.status == '2' || row.status == '3') {
          return {
            color: 'red'
          }
        }
      }
    },
  }

}
</script>

<style lang="scss" scoped>
.main {}
</style>
